import { Fragment } from "react";

import { PaymentResponse } from "@smart/bridge-types-basic";
import { entriesOf } from "@smart/itops-utils-basic";

export const SummaryPayment = ({
  response,
  fieldUri,
}: {
  response: PaymentResponse | undefined;
  fieldUri: string;
}) => {
  const getPaymentMessage = () => {
    if (!response?.chargeRequest)
      return <p className="text-ui">No payment made</p>;

    const chargeRequestDescription = response.chargeRequest.description;
    const charges = entriesOf(response?.charges || {});

    if (!charges.length)
      return (
        <p className="text-ui">
          Payment Pending
          {chargeRequestDescription ? ` - ${chargeRequestDescription}` : ""}
        </p>
      );

    return charges.map(([key, charge]) => {
      let status = "Payment Successful";
      let message = chargeRequestDescription;

      if (charge.status === "FAILED") {
        status = "Payment Failed";
        message =
          charge.smokeballResponse?.failure?.message ||
          "An unexpected error occurred during transaction processing";
      }

      return (
        <Fragment key={key}>
          <p className="text-ui">
            {status}
            {message ? ` - ${message}` : ""}
          </p>
        </Fragment>
      );
    });
  };

  return (
    <div
      className="flex flex-col gap-small rounded-[var(--input-brand-radius,0.8rem)] border border-neutral-100 p-[2.4rem]"
      data-testid={`payment-field-wrapper-${fieldUri}`}
    >
      {getPaymentMessage()}
    </div>
  );
};
